import {connect} from "react-redux"
import {createSelector} from "reselect"
import {setFiltersAlphabetAction} from "../../ducks/viewAllModal"
import State from "../../models/State"
import {DIGIT_REGEX} from "../../config/constants"

const selectViewAllModalAlphabet = (state: State) => state.text.pages.viewAllModal.alphabet
const selectFacets = (state: State) => state.search.facets

const makeSelectClickableAlphabet = createSelector([selectViewAllModalAlphabet, selectFacets], (alphabet, facets) => {
    const alphabetArray = alphabet.split(",")
    const clickableCharacters = alphabetArray.filter(character =>
        Object.entries(facets).some(entry => entry[1].n.toLowerCase().startsWith(character.toLowerCase())),
    )
    const clickableNumeric = Object.entries(facets).some(entry => DIGIT_REGEX.exec(entry[1].n))

    return {
        alphabet: alphabetArray,
        clickableCharacters,
        clickableNumeric,
    }
})

export const mapStateToProps = (state: State) => {
    const {alphabet, clickableCharacters, clickableNumeric} = makeSelectClickableAlphabet(state)

    return {
        alphabet,
        clickableCharacters,
        clickableNumeric,
        facets: state.viewAllModal.facets,
        activeCharacter: state.viewAllModal.activeCharacter,
        text: state.text,
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    handleSetFiltersAlphabet: (letter: string) => {
        dispatch(setFiltersAlphabetAction(letter))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
